import { Database } from "lucide-react";
import { cn } from "@/lib/utils";
import {
  etichetaBilant,
  etichetaIdentificare,
  tonIdentificare,
} from "@/utils/surseDateFormatting";
import type { SurseDate } from "@/types/identificareFirma";

type SurseDateBadgeProps = {
  surse: SurseDate | null | undefined;
  className?: string;
};

const TONURI: Record<string, string> = {
  verde: "border-ds-emerald-200 bg-ds-emerald-50 text-ds-emerald-700",
  galben: "border-ds-amber-500/30 bg-ds-amber-100 text-navy-800",
  neutru: "border-ds-border-200 bg-ds-surface-50 text-ds-text-500",
};

function SurseDateBadge({ surse, className }: SurseDateBadgeProps) {
  const identificare = etichetaIdentificare(surse?.identificare);
  const bilant = surse?.bilant ? etichetaBilant(surse.bilant) : "";

  if (!identificare && !bilant) return null;

  const ton =
    TONURI[tonIdentificare(surse?.identificare?.sursa)] ?? TONURI.neutru;

  return (
    <div
      className={cn(
        "flex flex-wrap items-center gap-2 rounded-lg border px-3 py-2 text-xs",
        ton,
        className
      )}
    >
      <Database className="h-3.5 w-3.5 shrink-0" />
      {identificare && <span>Date firmă: {identificare}</span>}
      {identificare && bilant && <span aria-hidden="true">·</span>}
      {bilant && <span>{bilant}</span>}
    </div>
  );
}

export default SurseDateBadge;
